import React from "react";
import { useCart } from "../contexts/CartContext";
import { useHamburgerMenu } from "../contexts/HamburgerMenuContext";

type CartButtonProps = {
  hasLabel?: boolean;
  className?: string; // Optional custom className for styling
};

const CartButton: React.FC<CartButtonProps> = ({ hasLabel, className }) => {
  const { isCartOpen, setIsCartOpen, cart } = useCart();
  const { setIsHamburgerMenuOpen } = useHamburgerMenu();

  const handleClick = () => {
    setIsCartOpen(!isCartOpen);
    setIsHamburgerMenuOpen(false);
  };

  const count = cart?.length ?? 0;

  return (
    <button
      onClick={handleClick}
      aria-label={
        count > 0
          ? `Cart, ${count} item${count === 1 ? "" : "s"}`
          : "Cart, empty"
      }
      aria-expanded={isCartOpen}
      className={`flex items-center justify-center gap-2 p-1.5 mb-1 transition duration-200 ${className}`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        focusable="false"
        className="feather feather-shopping-bag h-5 w-5"
      >
        <path d="M3 7h18v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z"></path>
        <path d="M8 7c0-2.2 1.8-4 4-4s4 1.8 4 4"></path>
        <path d="M8 7h8"></path>
      </svg>
      {count > 0 && (
        <span className="cart-badge" aria-hidden="true">
          {count}
        </span>
      )}
      {hasLabel && <span>Cart</span>}
    </button>
  );
};

export default CartButton;
